import useSWR from 'swr';
import getHolterByID from '../services/holter';

// talvez seja desnecessário por ser 1 linha só, mas quando é mais complexo, compensa.
export default function useHolter(id) {
  return useSWR(id ? ['holter', id] : null, () => getHolterByID(id));
}
